import React, { useContext, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "./Bloqueado.module.scss";

const Bloqueado = () => {
  const { logout, user } = useContext(AuthContext);
  const navigate = useNavigate();

  // Se chegou aqui sem estar logado (redirect falso), volta pro login
  useEffect(() => {
    if (!user) {
      navigate("/", { replace: true });
    }
  }, [user, navigate]);

  const handleLogout = () => {
    logout();
    navigate("/", { replace: true });
  };

  if (!user) return null; // evita flash da tela de bloqueado

  return (
    <div className="bloqueado-page">
      <div className="bloqueado-container">
        <h1>Acesso Bloqueado</h1>
        <p>O cliente associado à sua conta está inativo. Não é possível continuar.</p>
        <button onClick={handleLogout}>Voltar para Login</button>
      </div>
    </div>
  );
};

export default Bloqueado;